import React, { useContext, useEffect, useState } from "react";
import { Link } from "gatsby";
import Footer from "~components/Footer";
import Layout from "~components/Layout";
import SEO from "~components/SEO";
import { AppContext } from "~context/AppContext.jsx";

const ShippingPage = () => {
  const {
    activeCurrencySymbol
  } = useContext(AppContext);
  var shippingTerm;
  switch (process.env.GATSBY_REGION_CODE.toLowerCase()) {
    case `us`:
      shippingTerm = `We offer free shipping on orders over $60 shipped within United States. A standard shipping cost of $10 will be applied to orders under $60.`;
      break;
    case `nz`:
      shippingTerm = `We offer free shipping on orders over $60 shipped within New Zealand. A standard shipping cost of $10 will be applied to orders under $60.`;
      break;
    case `uk`:
      shippingTerm = `We offer free shipping on orders over £50 shipped within the United Kingdom. A standard shipping cost of £10 will be applied to orders under £50.`;
      break;
    default:
      shippingTerm = `We offer free shipping on orders over $60 shipped within Australia. A standard shipping cost of $10 will be applied to orders under $60.`;
      break;
  }
  return (
    <>
      <SEO
        customTitle="Shipping"
        customDescription="Shipping page"
        customKeywords="Shipping"
        path="/shipping"
      />

      <Layout className="shipping w-full relative">
        <section className="shipping__container grid">
          <div className="animation-appear-left-slow animation-delay-3 grid-end-5 xs:grid-end-12 grid-start-2 xs:grid-start-1 h-screen xs:h-auto sticky xs:relative top-0 xs:top-auto left-0 xs:left-auto pt-v6 xs:pt-24">
            <h1 className="f3">Shipping</h1>
          </div>
          <div className="terms-page__content animation-appear-right-slow animation-delay-3 grid-end-4 xs:grid-end-12 grid-start-7 xs:grid-start-1 pt-v6 xs:pt-8 whitespace-pre-wrap">
            <h4>1. Domestic orders</h4>

            <ul><li>{shippingTerm}</li></ul>

            <h4>2. International orders</h4>

            <ul><li>We offer carbon-neutral international shipping for a flat rate of {activeCurrencySymbol}30</li><li>International shipping is free on all orders {activeCurrencySymbol}100 or more. This is calculated after all coupons have been applied to the order.</li></ul>

            <h4>3. When will my order ship?</h4>

            <ul><li>Most orders ship within 1-2 business days of being placed.</li></ul>

            <h4>4. Can I change or cancel my order?</h4>

            <ul><li>If you would like to change or cancel your order, please get in touch with us on social media, or email us at team@paire.com.au before your order is shipped.</li></ul>

            <h4>5. How do I track my order?</h4>

            <ul><li>A shipping confirmation will be sent to the email you provide, with a tracking link once your order leaves our warehouse. </li></ul>
          </div>
        </section>
        <section className="shipping__container grid">
          <div className="animation-appear-left-slow animation-delay-3 grid-end-5 xs:grid-end-12 grid-start-2 xs:grid-start-1 h-screen xs:h-auto sticky xs:relative top-0 xs:top-auto left-0 xs:left-auto pt-v6 xs:pt-24">
            <h1 className="f3">Return</h1>
          </div>
          <div className="terms-page__content animation-appear-right-slow animation-delay-3 grid-end-4 xs:grid-end-12 grid-start-7 xs:grid-start-1 pt-v6 xs:pt-8 whitespace-pre-wrap">
            <p>We want you to feel good wearing your Paire as we are designing them. That's why we cover free returns (including free shipping) within 30 days of purchase. If you'd like to return your Paire, please reach out to us.</p>

            <h4>What should I do if I have received a faulty or incorrect item?</h4>

            <ul><li>Faulty and incorrect items within 30 days of purchase are eligible for a replacement, store credit or refund.</li><li>If it’s after 30 days we’d still like to help, so please email us at team@paire.com.au for a chat.</li><li>Products eligible for a refund or replacement are items with a manufacturing fault, have been damaged during shipping or the incorrect product has been received.</li></ul>

            <h4>How do I return my package?</h4>

            <ul><li>We cover free returns (including free shipping) within 30 days of purchase. If you'd like to return your Paire, please reach out to us.</li></ul>
          </div>
        </section>
      </Layout>

      <Footer />
    </>
  );
};

export default ShippingPage;
